/**
 * Relay Mutation Wrapper: GetGlobalUnpaidInvoiceSummary
 * 
 * PURPOSE:
 * - Fetches deduplicated global summary of unpaid invoices for banner display
 * - Solves overcount problem where invoices duplicated across orgs inflate totals
 * - Each invoice counted only once (by flexiId) regardless of how many orgs share it
 * 
 * USAGE:
 * - Called from OverdueBillsList when switching to Organizations View
 * - Result displayed in "Total unpaid" banner at top of page
 * - Separate from table data (which shows per-org breakdown from getOrganizationsWithUnpaidInvoices)
 * 
 * RELAY PATTERN:
 * - Uses REQUIRED_CHILDREN config to fetch mutation result
 * - No optimistic updates needed (data loads quickly)
 * - No store updates needed (banner uses state, not Relay store)
 * 
 * @module GetGlobalUnpaidInvoiceSummary
 */

import Relay from 'react-relay';

export default class GetGlobalUnpaidInvoiceSummary extends Relay.Mutation {
    /**
     * Specify the GraphQL mutation to execute
     */
    getMutation() {
        return Relay.QL`mutation { getGlobalUnpaidInvoiceSummary }`;
    }

    /**
     * Define all fields that might change (fat query)
     * Relay will intersect this with tracked queries
     */
    getFatQuery() {
        return Relay.QL`
            fragment on GetGlobalUnpaidInvoiceSummaryPayload {
                totalCZK
                totalEUR
                totalOther
                otherCurrency
            }
        `;
    }

    /**
     * Configure how to handle mutation result
     * REQUIRED_CHILDREN: Forces Relay to fetch specified fields and pass to callback
     */
    getConfigs() {
        return [{
            type: 'REQUIRED_CHILDREN',
            children: [
                Relay.QL`
                    fragment on GetGlobalUnpaidInvoiceSummaryPayload {
                        totalCZK
                        totalEUR
                        totalOther
                        otherCurrency
                    }
                `
            ]
        }];
    }

    /**
     * Variables to pass to mutation
     * No input required - backend fetches all unpaid invoices globally
     */
    getVariables() {
        return {};
    }
}
